import React, { createContext, useReducer, useEffect } from 'react';
import {Pedigree} from './pedigree';

export const Store = createContext();

// Add hashing method to String prototype
Object.defineProperty(String.prototype, 'hashCode', {
  value: function() {
    var hash = 0, i, chr;
    for (i = 0; i < this.length; i++) {
      chr   = this.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }
});

let currentStateHash = null;
let currentAction = null;

const initialState = {
    Group: '',
    Next: null,
    Autocomplete: [],
    Template: {
        ItemId: { value: '', auto: [] },
        LotId: { value: '', auto: [] }
    },
    PedigreeList: [],
	Pedigree: JSON.parse(JSON.stringify(Pedigree)),
	Dirty: false,
	User: 'ADMIN',
	PedType: 'USER'
};

function reducer(state, action) {
    currentAction = action.type;

  switch (action.type) {
    case 'FETCH_DATA':
      return { ...state, ...action.payload };
    case 'CLEAR_LOCAL_DATA':
      return { ...state, Pedigree };
    case 'UPDATE_LOCAL_DATA':
      return { ...state, ...action.payload };
    case 'CREATE_REMOTE_DATA':
      return { ...state, Pedigree: JSON.parse(JSON.stringify(Pedigree)), ...action.payload };
    case 'LOAD_REMOTE_DATA':
      return { ...state, ...action.payload };
    case 'DELETE_REMOTE_DATA':
      return { ...state, ...action.payload };
    case 'UPDATE_REMOTE_DATA':
      return { ...state, ...action.payload };
    case 'UPDATE_SEARCH_DATA':
      return { ...state, ...action.payload };
 
    default:
      return state;
  }
}

export function StoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const value = { state, dispatch };
  
    // handle dirty data before unload.
    window.addEventListener("beforeunload", function (e) {
        if ( !state.Dirty ) return undefined;

        var confirmationMessage = 'It looks like you have been editing something. '
                                + 'If you leave before saving, your changes will be lost.';

        (e || window.event).returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    });
    
  useEffect(() => { 
      const hash = JSON.stringify(state.Pedigree).hashCode();
      
      if (currentAction === "LOAD_REMOTE_DATA") currentStateHash = hash;
      state.Dirty = (currentStateHash !== null && currentStateHash !== hash);
    //   console.log("STATE", state);
  }, [state]);

  return <Store.Provider value={value}>{props.children}</Store.Provider>;
}
